module.exports = __webpack_public_path__ + "static/img/ISO27001.d7b39f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/ISO27001.jpg
// module id = Y1fn
// module chunks = 0